import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, tvsCashDrawer, tvsFAQ, tvsOtherHardware, tvsPOSFeatures, tvsPOSMachine, tvsPrinters, tvsScanner, videoTestimonial , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const TVSPOS = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    const tvsData = [
        {
            heading: `POS Machines`,
            content: <HardwareFeatures features={tvsPOSMachine} setDemoModal={setDemoModal} setHeading={setHeading} />,
        },
        {
            heading: `Printer`,
            content: <HardwareFeatures features={tvsPrinters} setDemoModal={setDemoModal} setHeading={setHeading} />,
        },
        {
            heading: `Cash Drawer`,
            content: <HardwareFeatures features={tvsCashDrawer} setDemoModal={setDemoModal} setHeading={setHeading} />,
        },
        {
            heading: `Barcode Scanner`,
            content: <HardwareFeatures features={tvsScanner} setDemoModal={setDemoModal} setHeading={setHeading} />,
        },
    ]

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo}><Image src="/assets/Integration/Hardwares/TVSE LOGO.png" alt="TVSE" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Top of The Line Business Operations</span><br />
                        <span className={styles.black_text}>With</span><span className={styles.blue_text}> TVS POS Terminals</span>
                    </h1>
                    <p className={styles.page_desc}>TVS Android POS Terminals are designed to provide a fast, secure, and reliable business operation for your daily transactions.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img}><Image src="/assets/hardware-partners/tvs/hero-img.webp" alt="tvse" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
                <h2>Witness The Leading Range of TVS POS Terminals</h2>
                <Tabs data={tvsData} style={{ position: "sticky" }} />
            </div>
            <AdvanceAnalyticsBanner heading={'Transform Your TVS Hardware Into a Complete POS Solution'} desc={"All your TVS device needs is a makeover of a dynamic and flexibly integrated POS software built to last with rapid billing, easy inventory management and extensive real-time reporting."} setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={tvsFAQ} heading={"FAQs for Hardware Compatibility of QueueBuster POS"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default TVSPOS